import { useState } from "react";

export default function ImageSlider({ images }) {
  const [index, setIndex] = useState(0);
  const [zoom, setZoom] = useState(null);

  if (!images?.length) return null;

  const prev = () =>
    setIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () =>
    setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <>
      <div className="relative mt-5 w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-50">
        <div className="relative aspect-[4/3]">
          <img
            src={images[index]}
            alt=""
            onClick={() => setZoom(images[index])}
            className="
              absolute inset-0
              w-full h-full
              object-contain
              cursor-zoom-in
              select-none
            "
          />
        </div>

        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 inline-flex items-center justify-center bg-white/85 hover:bg-white rounded-full text-lg text-slate-700 shadow-lg transition"
            >
              ←
            </button>
            <button
              onClick={next}
              className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 inline-flex items-center justify-center bg-white/85 hover:bg-white rounded-full text-lg text-slate-700 shadow-lg transition"
            >
              →
            </button>
          </>
        )}

        <div className="absolute bottom-3 right-3 text-xs bg-slate-900/75 text-white px-2 py-1 rounded-md">
          {index + 1} / {images.length}
        </div>
      </div>

      {zoom && (
        <div
          onClick={() => setZoom(null)}
          className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4"
        >
          <img
            src={zoom}
            alt=""
            className="
              max-w-[95vw]
              max-h-[95vh]
              object-contain
              rounded-xl
              bg-white
            "
          />
        </div>
      )}
    </>
  );
}
